import moment from "moment"

import tbcLogoSrc from "assets/img/tbc-logo.png"
import visaCardLogoSrc from "assets/img/visa-card-logo.png"

import { Flex, Box, Text, Image } from "@chakra-ui/react"
import Button from "components/UI/atoms/Button"
import { ITransaction } from "types/transaction"

export const getNestedColumns = (T: any, locale: string, handleRefundClick: any, refundDisabled: boolean) => [
  {
    key: "cards",
    render: (data: ITransaction) => (
      <Flex alignItems="center">
        <Box mr="15px" bgColor="white" borderRadius="xs" padding="5px">
          <Image h="20px" src={data?.bankLogo || tbcLogoSrc} />
        </Box>
        <Flex bgColor="white" borderRadius="xs" padding="5px" alignItems="center">
          <Image w="20px" src={data?.bankCardLogo || visaCardLogoSrc} mr="5px" />
          <Text fontWeight="600">{data?.bankCardMaskedNumber}</Text>
        </Flex>
        <Text ml="30px">{moment(data?.date).locale(locale).format("DD MMM, HH:mm:SS") || " - "}</Text>
      </Flex>
    ),
    styles: {
      width: "85%"
    }
  },
  {
    key: "return",
    render: (data: ITransaction) => (
      <Flex alignItems="center">
        {data.returendAmount !== undefined && (
          <Text mr="10px" flex="1">
            <strong>{T("transactions.table.columns.refund_transaction_title")}:</strong> {data.returendAmount}
          </Text>
        )}
        <Box flex="1">
          <Button
            isDisabled={data?.paymentStatusId === 3}
            _hover={{ backgroundColor: data?.paymentStatusId === 3 ? "#F30028" : "" }}
            text={T("transactions.table.columns.refund")}
            onClick={() => !refundDisabled && handleRefundClick(data)}
            variant="error"
            styles={{
              width: "149px",
              height: "34px",
              fontSize: "12px"
            }}
            opacity={(refundDisabled || (data?.returendAmount !== undefined && (data.returendAmount >= data.amount))) ? .3 : 1}
            pointerEvents={(data.returendAmount !== undefined && (data.returendAmount >= data.amount)) ? "none" : "auto"}
          />
        </Box>
      </Flex>
    ),
    styles: {
      width: "40%",
    },
  },
]
